import { Base64 } from 'js-base64';
import { InitiatePasswordResetDto, PasswordResetEmailVerificationResponseDto, PasswordResetVerificationDto, ResetPasswordDto, } from '@lucidlink/dto/web-service-api';
import { parserFromDto } from '#fetcher/parse-utils.ts';
import { prepareNewUserIdentity } from '../common';
export const createPasswordResetClient = ({ getUnauthenticatedFetcher, }) => {
    return new PasswordResetClientImpl(getUnauthenticatedFetcher);
};
export class PasswordResetClientImpl {
    getUnauthenticatedFetcher;
    passwordResetFetcher;
    timeoutId;
    constructor(getUnauthenticatedFetcher) {
        this.getUnauthenticatedFetcher = getUnauthenticatedFetcher;
    }
    async sendVerificationCode(email) {
        await this.getUnauthenticatedFetcher().put(['password-reset', 'init'], {
            body: InitiatePasswordResetDto.create({ email }),
        });
    }
    async verifyEmail(verifyEmailParams) {
        const { accessToken } = await this.getUnauthenticatedFetcher().put(['password-reset', 'email-verification'], {
            body: PasswordResetVerificationDto.create(verifyEmailParams),
            parser: parserFromDto(PasswordResetEmailVerificationResponseDto),
        });
        this.resetState();
        this.startResetTimer(getTtl(accessToken));
        this.passwordResetFetcher =
            this.getUnauthenticatedFetcher().createSubFetcher({
                getAccessToken: async (_) => Promise.resolve(accessToken),
            });
    }
    async resetPassword(resetPasswordParams) {
        const passwordResetFetcher = this.getPasswordResetFetcher();
        const userIdentity = await prepareNewUserIdentity(resetPasswordParams.newPassword);
        await passwordResetFetcher
            .put(['password-reset', 'reset'], {
            body: ResetPasswordDto.create(userIdentity),
        })
            .finally(() => {
            this.resetState();
        });
    }
    getPasswordResetFetcher = () => {
        if (!this.passwordResetFetcher) {
            throw new Error('You need to verify email first');
        }
        return this.passwordResetFetcher;
    };
    clearResetTimer = () => {
        clearTimeout(this.timeoutId);
        this.timeoutId = undefined;
    };
    startResetTimer = (ms) => {
        this.timeoutId = setTimeout(() => {
            this.resetState();
        }, ms);
    };
    resetState = () => {
        this.passwordResetFetcher = undefined;
        this.clearResetTimer();
    };
}
const decodeJwt = (token) => {
    const payloadB64 = token.split('.')[1];
    if (!payloadB64) {
        throw Error('Cannot parse token');
    }
    const payload = Base64.decode(payloadB64);
    return JSON.parse(payload);
};
const getTtl = (token) => {
    const jwt = decodeJwt(token);
    return (jwt.exp - jwt.iat) * 1000; // milliseconds
};
